import { useState, useEffect } from 'preact/hooks'

import { Button } from 'components/UI'

type Props = {
	onReSendClick: (e: Event) => Promise<void>
	isLoading: boolean
}

const WAITING_TIME_TO_SEND_EMAIL = 30

const ReSendTimerButton = ({ onReSendClick, isLoading }: Props) => {
	const [timer, setTimer] = useState(WAITING_TIME_TO_SEND_EMAIL)
	const [isSendingEmail, setIsSendingEmail] = useState(true)

	useEffect(() => {
		if (timer <= 0) {
			// Timer finished -> user can click again
			setIsSendingEmail(false)
			return
		}

		const intervalId = setInterval(() => {
			setTimer(t => t - 1)
		}, 1000)

		// eslint-disable-next-line consistent-return
		return () => clearInterval(intervalId)
	}, [timer])

	const handleClick = async (e: Event) => {
		setIsSendingEmail(true)
		await onReSendClick(e)
	}

	const buttonText = timer > 0 ? `Re-send Email (${timer}s)` : 'Re-send Email'

	return (
		<Button
			className='w-44'
			disabled={isSendingEmail}
			isLoading={isLoading}
			onClick={handleClick}
			text={buttonText}
		/>
	)
}

export { ReSendTimerButton }
